import { render, staticRenderFns } from "./StockScreen1.vue?vue&type=template&id=8db64468"
import script from "./StockScreen1.vue?vue&type=script&lang=js"
export * from "./StockScreen1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports